import { Question } from './QuestionsList';
import ReportQuestion from './ReportQuestion';
import ReportDashboards from './ReportDashboards';
import ReportStatistics from './ReportStatistics';

import styles  from './report.module.css';
import { useState } from 'react';

export interface ReportProps {
  client: string,
  surveyId: number,
  questions: Question[],
  filters: any
}

const Report = (props : ReportProps) => {
  const { client, surveyId, filters, questions } = props;
  const [ currentLoadedIndex, setCurrentLoadedIndex ] = useState(0);
  const [ dashboardLoaded, setDashboardLoaded ] = useState(false);

  console.log('Rendering Report');
  return <div className={`${styles.report} report_main`}>
    <ReportStatistics {...props} />
    <ReportDashboards {...props} onDataLoaded={() => setDashboardLoaded(true)} />
    {(questions||[]).map((q, idx) => 
      <ReportQuestion key={q.id} client={client} 
        surveyId={surveyId} filters={filters} question={q}
        shouldLoad={dashboardLoaded && currentLoadedIndex >= idx - 1}
        index={idx} onDataLoaded={setCurrentLoadedIndex} />
    )}
  </div>
}

export default Report;
